var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-cascader",
    _vm._b(
      {
        staticClass: "my-cascader",
        style: _vm._style,
        attrs: { props: _vm.options, disabled: _vm.disabled },
        model: {
          value: _vm._value,
          callback: function ($$v) {
            _vm._value = $$v
          },
          expression: "_value",
        },
      },
      "el-cascader",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }